import t from '@jetshop/intl';
import Accordion from '@jetshop/ui/Accordion/Accordion';
import React from 'react';
import styled from 'react-emotion';
import { ListAccordion } from './Mobile/ListAccordion';
import { SortAccordion } from './Mobile/SortAccordion';
import { ReactComponent as Cross } from '../../../svg/Cross.svg';

const Wrapper = styled('section')`
  background-color: ${({ theme }) => theme.colors.beige};
  height: 100%;

  .header {
    height: 79px;
    border-top: 6px solid ${({ theme }) => theme.colors.green};
    border-bottom: 1px solid ${({ theme }) => theme.colors.lightGreen};
    background-color: ${({ theme }) => theme.colors.white};
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0 0 1rem;

    h1 {
      font-weight: 500;
      font-size: 1rem;
      letter-spacing: 0.05em;
      font-variant: small-caps;
      text-transform: lowercase;
      color: ${({ theme }) => theme.colors.green};
    }

    button {
      padding: 1rem;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: transparent;

      svg {
        height: 13px;
        width: 13px;
        path {
          stroke: ${({ theme }) => theme.colors.almostBlack};
        }
      }
    }
  }
`;

export default ({ filters, sortOrders, close }) => {
  const isSortOrders = sortOrders.length !== 0;
  const isFilters = filters.length !== 0;

  return (
    <Wrapper className="sort-filter-drawer">
      <div className="header">
        <h1>
          {isSortOrders && isFilters
            ? t('Sort & Filter')
            : isSortOrders
            ? 'Sort'
            : 'Filter'}
        </h1>
        <button onClick={close}>
          <Cross />
        </button>
      </div>
      <div className="filters">
        {isSortOrders && (
          <Accordion single>
            {accordionProps => (
              <SortAccordion
                sortOrders={sortOrders}
                accordionProps={accordionProps}
              />
            )}
          </Accordion>
        )}
        {isFilters && (
          <Accordion single>
            {accordionProps => (
              <ListAccordion
                filters={filters}
                accordionProps={accordionProps}
              />
            )}
          </Accordion>
        )}
      </div>
    </Wrapper>
  );
};
